<template>
  <q-page padding>
    <PageHeader
      title="Respostas Questionário Emocional"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <q-card style="width: 97%" class="q-ml-md">
      <div class="q-pl-md q-pt-md">
        <p class="text-h5">Filtros:</p>
      </div>
      <q-card-section class="row">
        <q-input
          class="col-md-2 col-4"
          dense
          v-model="filtros.nome"
          outlined
          label="Nome"
        >
          <template v-slot:prepend>
            <q-icon name="public" />
          </template>
        </q-input>

        <q-input
          class="col-md-2 col-4 q-ml-sm"
          dense
          outlined
          v-model="filtros.dataInicio"
          label="Data Inicial:"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataInicio"
                  mask="DD/MM/YYYY"
                  :locale="myLocale"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <q-select
          class="col-3 q-ml-sm"
          dense
          :options="options"
          v-model="filtros.resposta"
          outlined
          label="Resposta"
        />

        <q-btn
          class="resp q-ml-sm"
          style="padding: 5px 20px; height: 45px"
          color="secondary"
          label="Exportar"
        />
      </q-card-section>

      <q-card-section class="row justify-around q-col-gutter-sm">
        <q-btn
          class="q-mt-md"
          style="padding: 5px 20px; height: 45px; width: 100%"
          color="primary"
          label="Filtrar"
          @click="filtrar"
        />
      </q-card-section>
    </q-card>
    <table-respostas :filtros="filtros" :atualizar="atualizar" />
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";

import TableRespostas from "../components/TableRespostas.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    TableRespostas,
    PageHeader,
  },
  setup() {
    const date = ref("");
    const atualizar = ref("1");
    const filtros = ref({
      resposta: "",

      nome: "",
      dataInicio: "",
    });

    const filtrar = async () => {
      atualizar.value++;
    };

    return {
      date,
      atualizar,
      filtrar,
      filtros,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      options: ["Todos", "Otimo", "Bem", "Regular", "Ruim", "Pessimo"],
      options2: [],
      options3: ["Vendedor"],
      options4: ["Teste Centros de Custox"],
    };
  },
};
</script>

<style scoped>
@media only screen and (max-width: 1023px) {
  .resp {
    margin-top: 20px;
    width: 100%;
    margin-left: 0px;
  }
}
</style>
